import React from 'react'
import EditText from 'blocks.simple/editText/editText'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import styles from './deviceSettings__videoPlayer.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { cn } from 'ethcss'
import { Typography } from 'atoms/Typography'
import { SwitchButton } from '../../../atoms/SwitchButton'

const DeviceSettingsVideoPlayer = (p_: {
    settings: { hardwareAcceleration: string; options: string[] }
    onChange: (data: any) => void
}) => {
    const options = p_.settings.options.join('\n')

    const onChange = (value: string, event: string | null, key = 'options') => {
        const data: any = {
            ...p_.settings,
        }

        if (key !== 'options') {
            data[key] = value
        } else {
            data[key] = value.split('\n')
        }

        p_.onChange(data)
    }

    return (
        <>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.settings.hardwareAcceleration === 'on'}
                    onChange={() => {
                        onChange(p_.settings.hardwareAcceleration === 'on' ? 'off' : 'on', null, 'hardwareAcceleration')
                    }}
                    className={`test-settings-toggle_${
                        p_.settings.hardwareAcceleration === 'on' ? 'enabled' : 'disabled'
                    }`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography className={cn(grid.mb_md)} type="title">
                        {translate('videoHardwareAcceleration')}
                    </Typography>
                </div>
            </div>
            <div className={styles.optionsWrapper}>
                <div className={styles.textArea}>
                    <EditText
                        mod={'withBorder'}
                        type="area"
                        label={translate('settings')}
                        value={options}
                        onChange={onChange}
                    />
                </div>
            </div>
        </>
    )
}

export default DeviceSettingsVideoPlayer
